import { UploadInfo } from '../../../model/product/general';
import { WizardFeatureState } from '../../../model/product/wizard';

export function updateUploadInfo(
  state: WizardFeatureState,
  id: string,
  updateFn: (info: UploadInfo) => UploadInfo,
): WizardFeatureState {
  if (state.value.productData.coverImages.some((image) => image.id === id)) {
    return {
      ...state,
      value: {
        ...state.value,
        productData: {
          ...state.value.productData,
          coverImages: state.value.productData.coverImages.map((image) =>
            image.id !== id
              ? image
              : {
                  ...image,
                  uploadInfo: updateFn(image.uploadInfo),
                },
          ),
        },
      },
    };
  } else if (state.value.tracklisting.some((track) => track.id === id)) {
    return {
      ...state,
      value: {
        ...state.value,
        tracklisting: state.value.tracklisting.map((track) =>
          track.id !== id || track.existing ? track : { ...track, uploadInfo: updateFn(track.uploadInfo) },
        ),
      },
    };
  } else if (state.value.tracksPreview?.id === id) {
    return {
      ...state,
      value: {
        ...state.value,
        tracksPreview: {
          ...state.value.tracksPreview,
          uploadInfo: updateFn(state.value.tracksPreview.uploadInfo),
        },
      },
    };
  }

  return state;
}

export function updateAllowed(
  newAllowed: boolean,
  oldValue: boolean | 'disallowed',
  preselect: boolean,
): boolean | 'disallowed' {
  if (!newAllowed) {
    return 'disallowed';
  }

  if (oldValue === 'disallowed') {
    return preselect;
  }

  return oldValue;
}

export function isAllowed(value: boolean | 'disallowed') {
  return value !== 'disallowed';
}

export function entrySet(value: boolean | 'disallowed') {
  return value === true;
}

export function entryUnset(value: boolean | 'disallowed') {
  return value === false;
}

export function onlyIfAllowed(oldValue: boolean | 'disallowed', newValue: boolean) {
  return oldValue !== 'disallowed' ? newValue : 'disallowed';
}

export function allSetOrDisallowed({
  download,
  streaming,
  ringtone,
  special,
}: {
  download: boolean | 'disallowed';
  streaming: boolean | 'disallowed';
  ringtone: boolean | 'disallowed';
  special: boolean | 'disallowed';
}) {
  return download && streaming && ringtone && special;
}
export function getAgeRatingOptions() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((o) => ({
    value: o.toString(),
    label:
      o === 1
        ? $localize`:@@product-wizard.spoken-word.age-option:From 1 year`
        : $localize`:@@product-wizard.spoken-word.age-option-plural:From ${o} years`,
  }));
}

export function getVersionOptions() {
  return [
    {
      value: 'abridged',
      label: $localize`:@@product-wizard.spoken-word.version-abridged:Abridged`,
    },
    {
      value: 'unabridged',
      label: $localize`:@@product-wizard.spoken-word.version-unabridged:Unabridged`,
    },
  ];
}
